import React from 'react';

import { useAppNavigation } from '../../../../hooks/useAppNavigation';

import { OrderStatus } from './OrderStatus';

import { AdaptiveModal } from '../../AdaptiveModal';

export const OrderStatusModal = () => {
  const { showOrderStatusModal, setShowOrderStatusModal } = useAppNavigation();

  return (
    <AdaptiveModal
      open={showOrderStatusModal}
      onOpen={setShowOrderStatusModal}
      contentStyle={{
        width: '90%',
        maxWidth: '400px',
        overflow: 'visible'
      }}
    >
      <OrderStatus />
    </AdaptiveModal>
  );
};
